"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestDepartmentAttachment = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
class IkeRestDepartmentAttachment {
    constructor(boundDepartment) {
        this.boundDepartment = boundDepartment;
    }
    set(fileName, buffer, contentType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const core = this.boundDepartment.boundUser.core;
            const headers = core.headers(this.boundDepartment.boundUser.accessToken, this.boundDepartment.departmentId);
            headers[core_api_1.IkeRequestHeader.FILE_NAME] = fileName;
            headers[core_api_1.IkeRequestHeader.CONTENT_TYPE] = contentType;
            const body = typeof buffer === 'string' ? new TextEncoder().encode(buffer) : new Uint8Array(buffer);
            const response = yield core.fetch(core.path(`/v1/action/attachment.create`), { method: 'POST', body, headers });
            if (response.ok) {
                yield core.validateIsJson(response);
                return response.json();
            }
            return core.handleError(response);
        });
    }
    get(attachmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const core = this.boundDepartment.boundUser.core;
            const response = yield core.actionRaw('attachment.data', { attachmentId }, this.boundDepartment.boundUser.accessToken, this.boundDepartment.departmentId);
            if (response.ok) {
                return response.body;
            }
            return core.handleError(response);
        });
    }
    info(attachmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.boundDepartment.action('attachment.get', { attachmentId });
        });
    }
    parse(attachmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const core = this.boundDepartment.boundUser.core;
            const response = yield core.actionRaw('attachment.parse', { attachmentId }, this.boundDepartment.boundUser.accessToken, this.boundDepartment.departmentId);
            if (response.ok) {
                yield core.validateIsJson(response);
                return response.json();
            }
            return core.handleError(response);
        });
    }
    virusScan(attachmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const core = this.boundDepartment.boundUser.core;
            const response = yield core.actionRaw('attachment.virus.scan', { attachmentId }, this.boundDepartment.boundUser.accessToken, this.boundDepartment.departmentId);
            if (response.ok) {
                yield core.validateIsJson(response);
                return response.json();
            }
            return core.handleError(response);
        });
    }
}
exports.IkeRestDepartmentAttachment = IkeRestDepartmentAttachment;
//# sourceMappingURL=rest.department.attachment.js.map